export default "__VITE_ASSET__07ca57aa__"